<template>
  <div>
    <slot name="activator">
      <Button round flat icon="more_vert" :color="buttonColor" />
    </slot>
    <q-menu
      ref="menu"
      :anchor="currentPosition.anchor"
      :self="currentPosition.self"
      :fit="fit"
      :persistent="persistent"
      :auto-close="autoClose"
    >
      <slot name="content">
        <List>
          <template v-for="item in items">
            <Item
              v-bind:key="item.key"
              clickable
              v-close-popup
              @click="$emit('click', item.key)"
              :class="`text-${item.color}`"
            >
              <ItemSection side v-if="item.icon">
                <Icon :name="item.icon" :color="item.color" />
              </ItemSection>
              <ItemSection>
                <ItemLabel class="text-no-wrap">{{ item.label }}</ItemLabel>
              </ItemSection>
            </Item>
          </template>
        </List>
      </slot>
    </q-menu>
  </div>
</template>

<script>
import Button from './Button';
import List from './List';
import Item from './Item';
import ItemSection from './ItemSection';
import ItemLabel from './ItemLabel';
import Icon from './Icon';

export default {
  name: 'DropdownMenu',
  components: { Button, List, Item, ItemSection, ItemLabel, Icon },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    position: {
      type: String,
      default: 'bottom',
    },
    fit: {
      type: Boolean,
      default: false,
    },
    buttonColor: {
      type: String,
      default: 'standard',
    },
    persistent: {
      type: Boolean,
      default: false,
    },
    autoClose: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    currentPosition() {
      let anchor;
      let self;

      switch (this.position) {
        case 'top':
          anchor = 'top left';
          self = 'bottom left';
          break;
        case 'bottom':
          anchor = 'bottom left';
          self = 'top left';
          break;
        case 'top right':
          anchor = 'top right';
          self = 'bottom right';
          break;
        case 'bottom right':
          anchor = 'bottom right';
          self = 'top right';
          break;
      }

      return { anchor, self };
    },
  },
  methods: {
    hide() {
      this.$refs['menu'].hide();
    },
  },
};
</script>

<style lang="scss" scoped></style>
